import Image from "next/image";
import Button from "../Micro/Button/Button";
import React from "react";
import { gsap } from "gsap";

type Props = {
  handleClose: () => void;
};

const PasswordedProjects = ({ handleClose }: Props) => {
  const imageRef = React.useRef(null);

  React.useEffect(() => {
    const image = imageRef.current;

    gsap.fromTo(
      image,
      { y: "100%" },
      {
        y: 0,
        duration: 1,
        ease: "power3.out",
      },
    );
  }, []);
  return (
    <main className="w-full rounded-2xl bg-white dark:bg-theme-color-light lg:h-[95vh] lg:dark:bg-theme-color 2xl:h-[60vh]">
      <div className="grid h-full grid-cols-1 lg:grid-cols-2">
        <div className="container mx-auto hidden items-center justify-center rounded-l-2xl bg-[#F3F6FC] dark:bg-theme-color lg:flex lg:h-full">
          <div ref={imageRef}>
            <Image
              priority
              src="https://cdn.brimble.io/onboarding-passworded-projects_zkh68l.svg"
              alt="analytics features"
              width={366}
              height={488}
            />
          </div>
        </div>
        <div className="container mx-auto flex w-full items-center rounded-t-2xl bg-[#F3F6FC] dark:!bg-theme-color lg:hidden lg:h-full lg:rounded-none">
          <Image
            src="https://cdn.brimble.io/onboarding-protection-mobile_gf2bns.svg"
            alt="analytics features"
            width={423}
            height={378}
          />
        </div>
        <div className="container mx-auto flex flex-col items-center rounded-2xl bg-white py-5 text-center dark:bg-theme-color-light lg:items-start lg:justify-center lg:bg-none lg:py-0 lg:pl-10 lg:text-start lg:dark:bg-theme-color">
          <div className="relative lg:bottom-14">
            <p className="hidden w-fit items-center justify-center rounded-full bg-light p-2 text-xs font-bold text-primary lg:flex">
              WELCOME TO BRIMBLE{" "}
            </p>
            <div data-aos="fade-up" data-aos-duration="900">
              <h1 className="max-w-sm pt-3 text-2xl font-bold lg:text-3xl">
                Secure Your Projects with Passworded Projects
              </h1>
              <p className="max-w-[330px] pt-5 text-sm leading-6 text-gray-dark">
                Safeguard your web projects with a password, granting exclusive
                access to authorised individuals.
              </p>
            </div>
            <div className="w-full px-5 py-12 lg:w-fit lg:px-0">
              <Button className="w-full" onClick={handleClose}>
                Nice! Let’s get to It
              </Button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PasswordedProjects;
